<ramme-med-tittel [tittel]="'Beslutninger' | translate">
  <ramme-innhold>
    <div class="beslutninger-liste">
      @for (beslutning of skjema().controls.eksisterende.controls; track beslutning.value.beslutningskjema!.id; let indeks = $index) {
        @if (!beslutning.value.erForslag) {
          <div class="beslutning-kontainer" [class.slettet]="beslutning.value.slettet" [attr.data-beslutning-id]="beslutning.value.beslutningskjema!.id"
               data-testid="eksisterende-beslutning-og-oppgaver" #beslutning_element>
            <div class="beslutning">
              <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
              <div class="skjema-og-forslag">
                <beslutning-skjema [skjema]="beslutning.controls.beslutningskjema" [gruppeId]="gruppeId()"/>
                @if (beslutning.value.visForslag) {
                  <ramme-med-tittel class="forslag">
                    <!-- tittel som komponent fordi vi stiler tittelen i scss -->
                    <ramme-tittel>{{ 'Forslag'|translate }}</ramme-tittel>
                    <ramme-innhold>
                      <div class="tittel">{{ beslutning.value.beslutning!.tittelForslag }}</div>
                      <div class="beskrivelse">
                        <html-formatert [innhold]="beslutning.value.beslutning!.beskrivelseForslag"/>
                      </div>
                    </ramme-innhold>
                  </ramme-med-tittel>
                }
              </div>
              @if (!beslutning.value.visForslag) {
                <!-- pakker button inn i en div da matTooltip ikke vises på button dersom disabled, plasserer tekst over da dette elementet fyller tilgjengelig vertikal plass, og teksten kommer da potensielt langt under knappen -->
                <div class="vis-saksbeskrivelse" [matTooltip]="visForslagHjelpetekst(beslutning)" matTooltipPosition="above">
                  <button mat-button color="primary" type="button" (click)="visForslag(beslutning)" [disabled]="!harForslagstekster(beslutning)" data-testid="vis-forslag-knapp">
                    {{ 'Vis forslag' | translate }}
                    <mat-icon iconPositionEnd>keyboard_arrow_down</mat-icon>
                  </button>
                </div>
              } @else {
                <button mat-button color="primary" type="button" (click)="skjulForslag(beslutning)" class="skjul-saksbeskrivelse">
                  {{ 'Skjul forslag' | translate }}
                  <mat-icon iconPositionEnd>keyboard_arrow_up</mat-icon>
                </button>
              }

              @if (beslutning.disabled) {
                <button mat-flat-button type="button" (click)="angreSlettEksisterendeBeslutning(beslutning)" class="angre-slett">
                  {{ 'Angre'|translate }}
                </button>
              } @else {
                <button mat-icon-button type="button" (click)="slettEksisterendeBeslutning(beslutning)" class="slett" data-testid="slett-beslutning-knapp">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
            <div class="oppgaver">
              @for (oppgave of beslutning.controls.oppgaver.controls.eksisterende.controls; track oppgave.value.oppgave!.id) {
                <div class="oppgave" [class.slettet]="oppgave.value.slettet" data-testid="eksisterende-oppgave">
                  <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon entitetikon"/>
                  <oppgave-skjema [skjema]="oppgave.controls.oppgave" [gruppeId]="gruppeId()"/>
                  @if (oppgave.disabled) {
                    <button mat-flat-button type="button" (click)="angreSlettEksisterendeOppgave(oppgave);" class="angre-slett">
                      {{ 'Angre'|translate }}
                    </button>
                  } @else {
                    <button mat-icon-button type="button" (click)="slettEksisterendeOppgave(oppgave);" class="slett" data-testid="slett-oppgave-knapp">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </div>
              }
              @for (oppgave of beslutning.controls.oppgaver.controls.nye.controls; track oppgave.value.oppgave!.id; let indeks = $index) {
                <div class="oppgave" data-testid="ny-oppgave">
                  <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon entitetikon"/>
                  <oppgave-skjema [skjema]="oppgave.controls.oppgave" [gruppeId]="gruppeId()" [tittelLabel]="'Ny oppgave under beslutning' | translate"/>
                  <button mat-icon-button type="button" (click)="slettNyOppgave(beslutning, indeks);" class="slett" data-testid="slett-oppgave-knapp">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      }

      <div class="nye">
        @for (beslutning of skjema().controls.nye.controls; track beslutning.value.beslutningskjema!.id; let indeks = $index) {
          <div class="beslutning-kontainer" [attr.data-beslutning-id]="beslutning.value.beslutningskjema!.id" data-testid="ny-beslutning-og-oppgaver" #beslutning_element>
            <div class="beslutning">
              <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
              <beslutning-skjema [skjema]="beslutning.controls.beslutningskjema" [gruppeId]="gruppeId()" [tittelLabel]="'Ny beslutning' | translate"/>
              <button mat-icon-button type="button" (click)="slettNyBeslutning(indeks);" class="slett" data-testid="slett-beslutning-knapp">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <div class="oppgaver">
              @for (oppgave of beslutning.controls.oppgaver.controls.nye.controls; track oppgave.value.oppgave!.id) {
                <div class="oppgave" data-testid="ny-oppgave">
                  <mat-icon fontSet="lederplan-ikon-oppgave" class="mat-icon--lederplan-ikon entitetikon"/>
                  <oppgave-skjema [skjema]="oppgave.controls.oppgave" [gruppeId]="gruppeId()" [tittelLabel]="'Ny oppgave under beslutning' | translate"/>
                  <button mat-icon-button type="button" (click)="slettNyOppgave(beslutning, indeks);" class="slett" data-testid="slett-oppgave-knapp">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </ramme-innhold>
</ramme-med-tittel>

@if (antallForslag() > 0) {
  <ramme-med-tittel [tittel]="'Forslag til beslutninger' | translate" class="forslag-liste">
    <ramme-innhold>
      @for (beslutning of skjema().controls.eksisterende.controls; track beslutning.value.beslutningskjema!.id) {
        @if (beslutning.value.erForslag) {
          @let forslag = beslutning.value.beslutning!;
          <div class="forslag-kontainer" data-testid="forslag-til-beslutning">
            <mat-icon fontSet="lederplan-ikon-beslutning" class="mat-icon--lederplan-ikon entitetikon"/>
            <div class="forslag">
              <div class="tittel" data-testid="forslag-tittel">{{ forslag.tittelForslag }}</div>
              <div class="beskrivelse" data-testid="forslag-beskrivelse">
                <html-formatert [innhold]="forslag.beskrivelseForslag"/>
              </div>
            </div>
            <button mat-button color="primary" type="button" (click)="registrerForslagSomBeslutning(beslutning);" data-testid="registrer-forslag-knapp">
              {{ 'Registrer som beslutning' | translate }}
            </button>
          </div>
        }
      }
    </ramme-innhold>
  </ramme-med-tittel>
}
